


















































































import Vue from 'vue';

export default Vue.extend({
  name: 'MainButton',
  props: {
    plain: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'main-button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    btnLoading: {
      type: Boolean,
      default: false,
    },
  },
});
